import { BLOCK_COMMANDS } from '../DocEditor/components/SlashCommandMenu';

/** Same slash list as the doc. Block commands are text; a number value drops them. */
export const TEXT_VALUE_SLASH_IDS = BLOCK_COMMANDS.map((cmd) => cmd.id);

/** A number value can only hold a formula. */
export const NUMBER_VALUE_SLASH_IDS = ['math'];

export const excludeSlashIds = (allowedIds) =>
  BLOCK_COMMANDS.map((cmd) => cmd.id).filter((id) => !allowedIds.includes(id));

/** "/" opens after the start of the field, whitespace, or a caret buffer. */
export const isSlashBoundary = (textBefore) => {
  const last = String(textBefore || '')[String(textBefore || '').length - 1];
  return !last || /\s/.test(last) || last === '\u200b';
};

/** Text after the latest "/", or null when there is no slash. */
export const slashQueryFrom = (text) => {
  const raw = String(text || '');
  const i = raw.lastIndexOf('/');
  if (i === -1) return null;
  return raw.slice(i + 1);
};

/** Drop the `/query` that opened the menu. Keeps anything before that slash. */
export const stripSlashQuery = (raw) => {
  const text = String(raw ?? '');
  const i = text.lastIndexOf('/');
  if (i === -1) return text;
  return text.slice(0, i) + text.slice(i).replace(/^\/\S*/, '');
};
